/**
 * Shared lookup and parse utilities for vehicle CRUD operations.
 * Eliminates duplication across Vehiculos/index.js, ModalFormVehiculo,
 * and ModalLeerVehiculo.
 */

// --- Lookup functions (return description or code if not found) ---

export const buscarNombreMarca = (codigo, marcas) => {
    if (Array.isArray(marcas) && marcas.length > 0)
        return marcas?.find(m => m.MARCAS == codigo)?.DESCRI || codigo;
    return codigo;
};

export const buscarNombreModelo = (codigo, modelos) => {
    if (Array.isArray(modelos) && modelos.length > 0)
        return modelos?.find(m => m.MODELO == codigo)?.DESCRI || codigo;
    return codigo;
};

export const buscarColor = (codigo, colores) => {
    if (Array.isArray(colores) && colores.length > 0)
        return colores?.find(m => m.codreg == codigo)?.descri || codigo;
    return codigo;
};

export const buscarTipoCombustible = (codigo, tiposCombustible) => {
    if (Array.isArray(tiposCombustible) && tiposCombustible.length > 0)
        return tiposCombustible?.find(m => m.codreg == codigo)?.descri || codigo;
    return codigo;
};

export const buscarTipoTraccion = (codigo, tiposTraccion) => {
    if (Array.isArray(tiposTraccion) && tiposTraccion.length > 0)
        return tiposTraccion?.find(m => m.codreg == codigo)?.descri || codigo;
    return codigo;
};

export const buscarTipoTransmision = (codigo, tiposTransmision) => {
    if (Array.isArray(tiposTransmision) && tiposTransmision.length > 0)
        return tiposTransmision?.find(m => m.codreg == codigo)?.descri || codigo;
    return codigo;
};

// --- Parse functions (convert API data to react-select format) ---

export const parseMarca = (marca) => {
    return { value: marca?.MARCAS, label: marca?.DESCRI };
};

export const parseModelo = (modelo) => {
    return { value: modelo?.MODELO, label: modelo?.DESCRI };
};

export const parseColor = (color) => {
    return { value: color?.codreg, label: color?.descri };
};

export const parseTiposTraccion = (tipoTraccion) => {
    return { value: tipoTraccion?.codreg, label: tipoTraccion?.descri };
};

export const parseTiposTransmision = (tipoTransmision) => {
    return { value: tipoTransmision?.codreg, label: tipoTransmision?.descri };
};

export const parseTiposCombustible = (tipoCombustible) => {
    return { value: tipoCombustible?.codreg, label: tipoCombustible?.descri };
};
